import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/en/contact")({
  head: () => pageHead("contact", "en"),
  component: Contact,
});
